<template>
  <modal
  :name="modalName"
  :adaptive="true"
  height="auto"
  :width="500"
  transition="linear"
  :delay="0.15"
  @before-close="beforeModalClose"
  >
    <div class="fp-modal holiday-schedule">

      <modals-header
        :modalNameProp="modalName"
        :infoTooltip="true"
        :infoTooltipTitle="$lang.messages.tp_holidayScheduleTitle"
        :infoTooltipText="$lang.messages.tp_holidayScheduleText"
        @hideModalProp="hide"
        @hideTooltip="hideTooltip"
        :key="rerenderTooltip">
      </modals-header>

      <hr class="v--modal-hr">
      <div class="holiday-container">
        <div
          v-for="(holiday, index) in holidays"
          :key="`holidayArr-${index}`"
        >
          <p>
            <b>{{holiday.name}}</b>
            {{holiday.durationDays > 0 ? dateFormat(holiday.date) + '–' + dateFormat(addDays(holiday.date, holiday.durationDays)) : dateFormat(holiday.date)}}</p>
          <autocomplete
              :items="coparents"
              :placeholder="$lang.messages.selectCoparent"
              :option="holidaySelectedCoparent[index]"
              :name="'payor'"
              :validateProp="validateProp"
              @optionChanged="onSelectedCoparent($event, index)"
              :key="rerender"
              ref="autocompletePayor" />
        </div>
      </div>
      <button
          type="button"
          class="generic-btn"
          @click="hide"
      >
        {{ $lang.messages.back }}
      </button>
      <button
          type="button"
          class="action-btn"
          @click="scheduleHolidays()"
      >
        <span v-show="!loading">Schedule Holidays</span>
        <ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
      </button>
    </div>
  </modal>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { ADD_NEW_VISITATION} from "@/store/action.types";
    import ModalsHeader from "@/components/common/modals/ModalsHeader";
    import Autocomplete from '@/components/common/Autocomplete';
    import { dateFormat, requestDateFormatUTC } from '@/mixins/dateFormat';
    import ClipLoader from 'vue-spinner/src/ClipLoader';
    import STATUS_CODES from "@/common/statusCodes";

    export default {
        name: "HolidayScheduleModal",
        components: {
          ModalsHeader,
          ClipLoader,
          Autocomplete,
        },
        mixins: [
            dateFormat,
            requestDateFormatUTC
        ],
        props: {
            year: {
                type: Number,
                required: true,
                default: () => {
                    return '';
                }
            },
            holidays: {
              type: Array,
              required: true,
              default: () => {
                return [];
              }
            },
            coparentArr: {
                type: Array,
                required: true,
                default: () => {
                    return [];
                }
            },
        },
        data() {
            return {
                modalName: 'Holiday Schedule',
                selectedCoparent: {},
                selectedChildren: [],
                validateProp: false,
                holidaySelectedCoparent: [],
                rerender: 0,
                holidayEventData: {
                    stayingWithMe: [],
                    stayingWithCoparent: []
                },
                tooltip: false,
                rerenderTooltip: 0,
                loading: false,
            }
        },
        computed: {
            ...mapGetters({
                coparentGuid: 'coparentGuid',
                coparentsStore: 'coparents',
            }),
            coparentName() {
                let name = '';

                for (let i of this.coparentsStore) {
                    if (i.guid === this.coparentGuid) {
                        name = i.name;
                        break;
                    }
                }

                return name;
            },
          coparents: function() {
              let x = [{ name: this.coparentName }];
              x.push({ name: this.selectedCoparent.coparentName });
              return x;
          }
        },
        watch: {
          coparentArr: function (val) {
            for (let v of val) {
              for (let h = 0; h < this.holidays.length; h++) {
                if (v.date === this.holidays[h].date) {
                  this.onSelectedCoparent({name: v.coparent}, h);
                  this.holidaySelectedCoparent[h] = {name: v.coparent};
                  this.rerender++;
                }
              }
            }
          }
        },
        mounted() {
        },
        methods: {
            ...mapActions({
                postNewVisitation: ADD_NEW_VISITATION
            }),
          show(selectedCoparent, selectedChildren) {
              this.selectedCoparent = selectedCoparent;
              this.selectedChildren = selectedChildren;
              this.$modal.show(this.modalName);
          },
          hide() {
            this.holidayEventData = {
              stayingWithMe: [],
              stayingWithCoparent: []
            };
            this.$modal.hide(this.modalName)
          },
          beforeModalClose() {
            this.holidayEventData = {
                stayingWithMe: [],
                stayingWithCoparent: []
            };
            this.holidaySelectedCoparent = [];
            this.rerender++;
          },
          reloadSelection() {
              this.$emit('reloadSelection');
          },
          addDays(date, days) {
            let result = new Date(date);
            result.setTime(result.getTime() + result.getTimezoneOffset() * 60000);
            result.setDate(result.getDate() + days);
            return this.requestDateFormatUTC(result);
          },
          onSelectedCoparent(value, index) {
              if (value.name === this.coparentName) {
                  if (this.holidayEventData.stayingWithCoparent.indexOf(this.holidays[index].date) !== -1) {
                      this.holidayEventData.stayingWithCoparent.splice(this.holidayEventData.stayingWithCoparent.indexOf(this.holidays[index].date), (this.holidays[index].durationDays + 1));
                  }
                  for (let i = 0; i <= this.holidays[index].durationDays; i++) {
                      this.holidayEventData.stayingWithMe.push(this.addDays(this.holidays[index].date, i));
                  }
              }
              else {
                  if (this.holidayEventData.stayingWithMe.indexOf(this.holidays[index].date) !== -1) {
                      this.holidayEventData.stayingWithMe.splice(this.holidayEventData.stayingWithMe.indexOf(this.holidays[index].date), (this.holidays[index].durationDays + 1));
                  }
                  for (let i = 0; i <= this.holidays[index].durationDays; i++) {
                      this.holidayEventData.stayingWithCoparent.push(this.addDays(this.holidays[index].date, i));
                  }
              }
          },
          scheduleHolidays() {
              if (!this.loading) {
                this.loading = true;
                this.postNewVisitation({
                  childrenGuids: this.selectedChildren,
                  coparentGuid: this.selectedCoparent.coparentGuid,
                  coparentDates: this.holidayEventData.stayingWithCoparent,
                  loggedCoparentDates: this.holidayEventData.stayingWithMe
                }).then(() => {
                  this.reloadSelection();
                  this.loading = false;
                  this.hide()
                }).catch(error => {
                  this.loading = false;
                  if (error.response && (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402)) {
                    this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
                  }
                });
              }
          },
          hideTooltip() {
            this.tooltip = false;
            this.rerenderTooltip+=1;
          },
        }
    }
</script>
